import { useEffect, useState } from "react";

export const useTimer = () => {
  const [pinTimer, setPinTimer] = useState(0);

  useEffect(() => {
    if (pinTimer) {
      const decrementPinTimer = () => {
        setPinTimer(currentTime => currentTime - 1)
      };
      const timeout = setTimeout(decrementPinTimer, 1000);
      return () => { clearTimeout(timeout); };
    }
  }, [pinTimer]);

  return { pinTimer, setPinTimer };
}

const formatTimer = totalSeconds => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const minutesStr = minutes.toString();
  const secondsStr = seconds.toString().padStart(2, "0");
  return `${minutesStr}:${secondsStr}`;
};

export default formatTimer;
